import React from 'react';
import { usePipelineData } from './hooks/usePipelineData';
import { usePipelineStages } from './hooks/usePipelineStages';
import { PipelineStages } from './components/PipelineStages';
import { ContentSection } from './components/ContentSection';
import { Card } from './components/Card';
import { PIPELINE_STAGES } from './constants/stages.constants';
import './styles/pipeline.css';
import './styles/PipelineLayout.css';

/**
 * Pipeline Tab Component
 * Available for Bureau and Admin roles only
 */
export const PipelineTab: React.FC = () => {
  const { data: expertiseData = [], isLoading, error } = usePipelineData();
  const { totalExpertises } = usePipelineStages(expertiseData);

  // Loading state
  if (isLoading) {
    return (
      <div className="pipeline-page-container">
        <div className="loading-container">
          <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600"></div>
        </div>
      </div>
    );
  }

  // Error state
  if (error) {
    return (
      <div className="pipeline-page-container">
        <div className="pipeline-header">
          <div className="pipeline-header-content">
            <div className="pipeline-title-row">
              <div>
                <h1 className="pipeline-title">Pipeline des Expertises</h1>
                <p className="pipeline-subtitle">Vue d'ensemble de toutes les expertises en cours de traitement</p>
              </div>
            </div>
          </div>
        </div>
        <div className="pipeline-content">
          <div className="pipeline-content-inner">
            <ContentSection variant="bordered">
              <div className="error-container">
                <p>Erreur: {error.message}</p>
                <button onClick={() => window.location.reload()}>
                  Réessayer
                </button>
              </div>
            </ContentSection>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="pipeline-page-container">
      <div className="pipeline-header">
        <div className="pipeline-header-content">
          <div className="pipeline-title-row">
            <div>
              <h1 className="pipeline-title">Pipeline des Expertises</h1>
              <p className="pipeline-subtitle">Vue d'ensemble de toutes les expertises en cours de traitement</p>
            </div>
            <div className="pipeline-header-actions">
              <Card variant="flat" padding="small">
                <div className="stats-container">
                  <span className="stats-number">{totalExpertises}</span>
                  <span className="stats-label">Expertises totales</span>
                </div>
              </Card>
            </div>
          </div>
        </div>
      </div>
      
      <div className="pipeline-content">
        <div className="pipeline-content-inner">
          <ContentSection variant="transparent" spacing="large">
            <PipelineStages
              stages={PIPELINE_STAGES}
              expertises={expertiseData}
            />
          </ContentSection>
        </div>
      </div>
    </div>
  );
};